import { APEX_API_URL } from '@/constants';
import { IZone } from '@/enums';
import { ILocation, LocationData, LocationListParams } from '@/interfaces/location';
import { IAutoCompleteStoreList, IStoreLists } from '@/interfaces/store';
import { getAxiosInstance } from '@/utils/axios-instance';

export const getLocationLists = async (locationId?: string): Promise<ILocation[]> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/location/locationId`, {
    params: {
      locationId,
    },
  });
  return response.data;
};

export const getAllLocationLists = async (params: LocationListParams = {}): Promise<LocationData> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/location/locations`, {
    params: params,
  });
  return response.data;
};

export const getStoreLists = async (
  name?: string,
  divisionId?: string,
  districtId?: string,
  thanaId?: string,
  latitude?: number,
  longitude?: number,
  IsBOPIS?: boolean | null,
  IsShowMapPage?: boolean,
  accessToken?: string,
): Promise<IStoreLists[]> => {
  const headers: Record<string, string> = {};
  const params: Record<string, any> = {
    name,
    divisionId,
    districtId,
    thanaId,
    latitude,
    longitude,
    IsBOPIS,
    IsShowMapPage,
  };

  let url = `${APEX_API_URL}/api/store/list`;

  // This enables fetching user's cart specific stores (only the stores which contain the cart products)
  if (IsBOPIS && accessToken) {
    url += '/store-changed';
    headers.Authorization = `Bearer ${accessToken}`;
    params.IsBopisStoreChanged = true;
  }

  const response = await getAxiosInstance().get(url, { params, headers });
  return response.data;
};

export const getStoreForFeedbackLists = async (
  name?: string,
  locationId?: string,
  latitude?: number,
  longitude?: number,
  IsGetAll?: boolean,
  IsOrderByDisplayOrderDESC?: boolean,
): Promise<IStoreLists[]> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/ticket/store-list`, {
    params: {
      name,
      locationId,
      latitude,
      longitude,
      IsGetAll,
      IsOrderByDisplayOrderDESC,
    },
  });

  return response.data;
};

export const getAllExpressZones = async (thanaId: string): Promise<IZone> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/delivery/express`, {
    params: {
      thanaId,
    },
  });
  return response.data;
};

export const getAutoCompleteStoreLists = async (query: string, limit?: number): Promise<IAutoCompleteStoreList> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/store/autocomplete`, {
    params: {
      query,
      limit,
    },
  });
  return response.data;
};
